//import $ from 'jquery';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';

export default class {

	constructor(options) {

		// OPTIONS
		this.defaults = {

			$el: undefined,

			arrows: true,
			autoplay: true,
			pauseOnHover: true,
			dots: true,
			autosize: false,
			fade: false,
			// cover/contain/constant_height
			// constant_height = All Images stay in frame with constant height and variable width ...
			image_mode: 'contain',
			default_index: 0,
			time_t_on: 0.75,
			time_t_off: 0.6,
			time_between_slides: 3000

		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'slideshow_wipe';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// init!!!!
		if ( this.$el.length > 0 ){
			this.init();
		}

	}

	init(){

		// vars
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		this.touch = !$('html').hasClass('no-touch');
		this.slides = [];

		this.index = this.options.default_index;
		this.prev_index = -1;
		this.timeout = -1;
		this.running = false;
		this.over = false;

		this.initSlider( true );
		this.addEvents( true );
		this.onResize();
	}

	initSlider( b ){
		if ( b ){

			this.$el.find( '.slide' ).each( (i, el ) => {
				this.slides[i] = $(el);
				if ( this.options.fade ){
					this.slides[i].css({
						opacity: 0
					});
				}
			} );
			if ( this.slides.length > 0 ){
				setTimeout( () => {
						this.setSlide( this.index );
				}, 17);
			}
		}
	}

	setSlide( i ){
		let $s, $c, $cap, tl, $n;

		this.running = true;

		if ( this.prev_index !== -1 ){

			$s    = this.slides[this.prev_index];
			$c    = $s.find( '.curtain' );
			$cap  = $s.find( '.caption' );
			//$img  = $s.find( '.img');

			tl = gsap.timeline({});

			if ( this.options.fade ){
				$s.css({
						'z-index': this.slides.length + 1
				});
				$n    = this.slides[this.index];
				$n.css({
					'z-index': this.slides.length + 2
				});
				

				// fade out 
				tl.fromTo( $cap, {opacity:1}, {opacity:0,duration:0.2} );
				tl.fromTo( $s, {opacity:1},{opacity:0, ease:'power2.out',duration:this.options.time_t_off});

				// fade in
				tl.fromTo( $n, {opacity:0},{opacity:1, ease:'power2.out',duration:this.options.time_t_on,
					onComplete: () => {
						this.onSetSlide();
					}
				}, "-="+this.options.time_t_off);

				// set Captions
				$cap  = $n.find( '.caption' );
				tl.fromTo( $cap, {opacity:0}, {opacity:1,duration:0.6}, "-=" + this.options.time_t_on/2 );
			}
			else{

				tl.to( $cap, {opacity:0,duration:0.3} );
				tl.fromTo( $c, {y:'100%'},{y:'0%',duration:this.options.time_t_off,ease:'power2.out', 
					onStart:function(){

					},
					onComplete: () => {
						this.slides[this.prev_index].css({
								'z-index': this.slides.length + 1
						});
						$s    = this.slides[this.index];
						$s.css({
							'z-index': this.slides.length + 2
						});
					
				}}, "-=0.3" );

				//tl.fromTo( $s, {y:'0%'},{y:'-5%',duration:this.options.time_t_off,ease:'power2.out'},  "-=0.3" );

				tl.fromTo( this.slides[this.index].find( '.curtain' ), {y:'0%'},{y:'-100%',duration:this.options.time_t_on,ease:'power4.in',
					onStart: () => {                
						$s    = this.slides[this.index];
						$c    = $s.find( '.curtain' );
						$cap  = $s.find( '.caption' );
						//$img  = $s.find( '.img' );
						//gsap.set( $s, {opacity:1} );
						gsap.fromTo( $s, {opacity:0},{opacity:1,duration:this.options.time_t_on,ease:'power.out',delay:0.3});
						gsap.to( $cap, {opacity:1,duration:0.6,delay:this.options.time_t_on});
					},
					onComplete:() => {
						this.onSetSlide();
					}
				}, "-=0.7");

			}

		}
		else{

			// first slide 
			$s    = this.slides[this.index];
			$c    = $s.find( '.curtain' );
			$cap  = $s.find( '.caption' );
			//$img  = $s.find( '.img');

			$s.css({
				'z-index': this.slides.length + 2
			});
			gsap.fromTo( $s, {opacity:0},{opacity:1,duration:this.options.time_t_on,ease:'power.out',delay:0});
			gsap.to( $cap, {opacity:1,duration:0.3,delay:this.options.time_t_on});
			gsap.fromTo( $c, {y:'0%'},{y:'-100%',delay:0.4, duration:this.options.time_t_on,ease:'power2.in', onComplete:() => {
				if ( this.options.fade ){
					this.$el.find(  '.curtain' ).css({
						visibility: 'hidden'
					});
				}
				this.onSetSlide();
			}});

			this.$el.find( '.arrow.arrow-left' ).addClass( 'reveal' )

		}

		this.$el.find( '.slick-dots li' ).each( (j, el) => {
			if ( j === i ){
				$(el).addClass('slick-active');
			}
			else{
				$(el).removeClass('slick-active');
			}
		});
	}

	onSetSlide(){
		this.running = false;
		this.setAutoPlay();
	}

	setAutoPlay(){
		if ( this.options.pauseOnHover ){
			if ( this.over ){
				return;
			}
		}
		if ( this.options.autoplay ){
			clearTimeout( this.timeout );
			this.timeout = setTimeout( () => {
				this.setNextSlide();
			}, this.options.time_between_slides );
		}
	}

	setNextSlide(){
		if ( this.running ){
			return;
		}
		clearTimeout( this.timeout );
		this.prev_index = this.index;
		this.index += 1;
		if ( this.index >= this.slides.length ){
			this.index = 0;
		}
		this.setSlide( this.index );
	}

	setPrevSlide(){
		if ( this.running ){
			return;
		}
		clearTimeout( this.timeout );
		this.prev_index = this.index;
		this.index -= 1;
		if ( this.index < 0 ){
			this.index = this.slides.length - 1;
		}
		this.setSlide( this.index );
	}

	onClickDot( i ){
		if ( this.running ){
			return;
		}
		if ( i !== this.index ){
			clearTimeout( this.timeout );
			this.prev_index = this.index;
			this.index = i;
			this.setSlide( this.index );
		}
	}

	addEvents( b ){
		let j;
		if ( b ){
			this.$el.on( 'mouseenter', () => {
				this.over = true;
				if ( this.options.autoplay && this.options.pauseOnHover ){
					clearTimeout( this.timeout );
				}
			});
			this.$el.on( 'mouseleave', () => {
				this.over = false;
				if ( this.options.autoplay && this.options.pauseOnHover ){
					if ( this.running ){
						//this.setAutoPlay();
					}
					else{
						//this.setNextSlide();
						this.setAutoPlay();
					}
				}
			});

			if( this.options.arrows ){
				this.$el.find( '.arrow' ).on( 'click', (e) => {
					if ( $(e.target).hasClass( 'left' ) ){
						this.setPrevSlide();
					}
					else{
						this.setNextSlide();
					}
				});
			}

			this.$el.find( '.slick-dots button' ).on( 'click', (e) => {
				j = parseInt($(e.target).text()) - 1;
				this.onClickDot( j )
			});
		}
		else{
			this.$el.off( 'mouseenter' );
			this.$el.off( 'mouseleave' );

			if( this.options.arrows ){
					this.$el.find( '.arrow' ).off( 'click' );
			}
		}
		this.debounceResize(b);
		this.attachEventsKeyBoard(b);
	}



	FORCE_IMAGE_LOAD(){
		//console.log( 'FORCE_IMAGE_LOAD' );
		this.$el.find( 'img' ).addClass( 'lazypreload' );
	}
	
	debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => { this.onResize() }, 17 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
	}

	onResize(){
		let availWidth = this.$el.find('.slides-container').width(), availHeight = this.$el.find('.slides-container').height(), i, $s, p, w, h;
		for( i=0; i<this.slides.length; i++ ){
			$s = this.slides[i].find( '.img-sizer' );
			w = parseInt( $s.attr('data-width') );
			h = parseInt( $s.attr('data-height') );

			if ( this.options.image_mode === 'contain' ){
				p = Math.max( w/availWidth,  h/availHeight );
				$s.css({
					width: Math.round(w/p),
					height: Math.round(h/p)
				})         
			}
			else if ( this.options.image_mode === 'constant_height' ){
				$s.css({
					width: Math.round(w*availHeight/h),
					height: availHeight
				})
			}
			else{  
				// cover
				p = Math.max( availWidth/w,  availHeight/h );
				$s.css({
					width: Math.round(w*p),
					height:  Math.round(h*p)
				})
			}
		}
	}

	attachEventsKeyBoard( b ){
		if ( b ){      
			this.$doc.on( 'keydown' , (e) => {
				if( e.which === 39 || e.which === 40 ){
					// right arrow or dn
					this.setNextSlide();
				}
				else if ( e.which === 37 || e.which === 38 ){
					// left arrow or up
					this.setPrevSlide();
				}
			});
		}
		else{
			this.$doc.off( 'keydown' );
		}
	}

	getImagesProportion(){
		let $slide = this.$el.find( '.slick-slide:eq(0)' ), $wrapper, p;
		$wrapper = $slide.find( '.img-wrapper' );
		if ( $wrapper.length > 0 ){
			p = parseInt( $wrapper.attr('data-height') )/parseInt( $wrapper.attr('data-width') )
			return p;
		}
		return false;
	}

	sizeImages(){
		let p = this.getImagesProportion();
		if ( p ){
			let $r = this.$el.find('.img-wrapper');
			if ( $r.length > 0 ){
				$r.css({
					'padding-bottom' : (p*100) + '%'
				})
			}
		}
	}

	// public methods //////////////////////////////////////////////////////////////////////////
	destroy(){
		this.initSlider( false );
		this.addEvents( false );
	}

}
